'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var PropTypes = require('prop-types');
var BackIcon = require('./BackIcon.js');
var BellIcon = require('./BellIcon.js');
var CalendarIcon = require('./CalendarIcon.js');
var CheckboxSelectedIcon = require('./CheckboxSelectedIcon.js');
var CheckboxUnselectedIcon = require('./CheckboxUnselectedIcon.js');
var ChevronDownIcon = require('./ChevronDownIcon.js');
var ChevronLeftIcon = require('./ChevronLeftIcon.js');
var ChevronRightIcon = require('./ChevronRightIcon.js');
var ChevronUpIcon = require('./ChevronUpIcon.js');
var CloseIcon = require('./CloseIcon.js');
var ContactChatIcon = require('./ContactChatIcon.js');
var ContactEmailIcon = require('./ContactEmailIcon.js');
var ContactPhoneIcon = require('./ContactPhoneIcon.js');
var ContactWorldWideWebsiteIcon = require('./ContactWorldWideWebsiteIcon.js');
var CreditCardIcon = require('./CreditCardIcon.js');
var DatePickerIcon = require('./DatePickerIcon.js');
var DeleteIcon = require('./DeleteIcon.js');
var DownIcon = require('./DownIcon.js');
var DownloadIcon = require('./DownloadIcon.js');
var EditIcon = require('./EditIcon.js');
var ErrorIcon = require('./ErrorIcon.js');
var FilterIcon = require('./FilterIcon.js');
var ForwardIcon = require('./ForwardIcon.js');
var FulfillmentDeliveryIcon = require('./FulfillmentDeliveryIcon.js');
var InfoIcon = require('./InfoIcon.js');
var KitIcon = require('./KitIcon.js');
var LocationPinIcon = require('./LocationPinIcon.js');
var MenuIcon = require('./MenuIcon.js');
var MinusIcon = require('./MinusIcon.js');
var NonReturnableIcon = require('./NonReturnableIcon.js');
var OrderIcon = require('./OrderIcon.js');
var PdfIcon = require('./PdfIcon.js');
var PlusIcon = require('./PlusIcon.js');
var PreferencesIcon = require('./PreferencesIcon.js');
var PrintIcon = require('./PrintIcon.js');
var ProfileIcon = require('./ProfileIcon.js');
var QuestionIcon = require('./QuestionIcon.js');
var QuoteIcon = require('./QuoteIcon.js');
var RadioButtonSelectedIcon = require('./RadioButtonSelectedIcon.js');
var RadioButtonUnselectedIcon = require('./RadioButtonUnselectedIcon.js');
var RemanufacturedIcon = require('./RemanufacturedIcon.js');
var ReorderIcon = require('./ReorderIcon.js');
var SaleIcon = require('./SaleIcon.js');
var SaveIcon = require('./SaveIcon.js');
var SearchIcon = require('./SearchIcon.js');
var ShareIcon = require('./ShareIcon.js');
var ShoppingCartIcon = require('./ShoppingCartIcon.js');
var SocialFacebookIcon = require('./SocialFacebookIcon.js');
var SocialLinkedInIcon = require('./SocialLinkedInIcon.js');
var SocialTwitterIcon = require('./SocialTwitterIcon.js');
var SocialYouTubeIcon = require('./SocialYouTubeIcon.js');
var SortByIcon = require('./SortByIcon.js');
var StarIcon = require('./StarIcon.js');
var StoreIcon = require('./StoreIcon.js');
var SuccessIcon = require('./SuccessIcon.js');
var SyncIcon = require('./SyncIcon.js');
var UpIcon = require('./UpIcon.js');
var ViewGridIcon = require('./ViewGridIcon.js');
var ViewListIcon = require('./ViewListIcon.js');
var WaffleIcon = require('./WaffleIcon.js');
var WarningIcon = require('./WarningIcon.js');
var WarningOutlineIcon = require('./WarningOutlineIcon.js');
var ActionsIcon = require('./ActionsIcon.js');
var PrivateIcon = require('./PrivateIcon.js');
var SharedIcon = require('./SharedIcon.js');
var ArrowDownIcon = require('./ArrowDownIcon.js');
var ArrowUpIcon = require('./ArrowUpIcon.js');
var AttachmentIcon = require('./AttachmentIcon.js');
var MinusLightIcon = require('./MinusLightIcon.js');
var PartialSuccessIcon = require('./PartialSuccessIcon.js');
var VisaIcon = require('./VisaIcon.js');
var MIRIcon = require('./MIRIcon.js');
var MaestroIcon = require('./MaestroIcon.js');
var MastercardIcon = require('./MastercardIcon.js');
var DiscoverIcon = require('./DiscoverIcon.js');
var AmericanExIcon = require('./AmericanExIcon.js');
var PaypalIcon = require('./PaypalIcon.js');
var JCBIcon = require('./JCBIcon.js');
var ReplacementPartIcon = require('./ReplacementPartIcon.js');
var CatCardIcon = require('./CatCardIcon.js');
var ExportIcon = require('./ExportIcon.js');
var ClipboardIcon = require('./ClipboardIcon.js');
var CheckIcon = require('./CheckIcon.js');
var OpenInNewTabIcon = require('./OpenInNewTabIcon.js');
var HelpIcon = require('./HelpIcon.js');
var RepairServiceIcon = require('./RepairServiceIcon.js');
var DashboardIcon = require('./DashboardIcon.js');
var SquareHelpIcon = require('./SquareHelpIcon.js');
var FilterIconAlt = require('./FilterIconAlt.js');
var FilterIconAltFill = require('./FilterIconAltFill.js');
var VisibilityOffIcon = require('./VisibilityOffIcon.js');
var FilledStarIcon = require('./FilledStarIcon.js');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["icon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AlloyIcon = function AlloyIcon(props) {
  var ICON_NOT_FOUND_ERROR = 'Unable to find icon';
  var icon = props.icon,
    otherProps = _objectWithoutProperties__default.default(props, _excluded);
  var iconMap = {
    'icon-amex': AmericanExIcon.default,
    'icon-arrow-up': ArrowUpIcon.default,
    'icon-arrow-down': ArrowDownIcon.default,
    'icon-back': BackIcon.default,
    'icon-bell': BellIcon.default,
    'icon-calendar': CalendarIcon.default,
    'icon-checkbox-selected': CheckboxSelectedIcon.default,
    'icon-checkbox-unselected': CheckboxUnselectedIcon.default,
    'icon-chevron-down': ChevronDownIcon.default,
    'icon-chevron-left': ChevronLeftIcon.default,
    'icon-chevron-right': ChevronRightIcon.default,
    'icon-chevron-up': ChevronUpIcon.default,
    'icon-clipboard': ClipboardIcon.default,
    'icon-close': CloseIcon.default,
    'icon-contact-chat': ContactChatIcon.default,
    'icon-contact-email': ContactEmailIcon.default,
    'icon-contact-phone': ContactPhoneIcon.default,
    'icon-contact-worldwidewebsite': ContactWorldWideWebsiteIcon.default,
    'icon-credit-card': CreditCardIcon.default,
    'icon-dashboard': DashboardIcon.default,
    'icon-datepicker': DatePickerIcon.default,
    'icon-delete': DeleteIcon.default,
    'icon-discover': DiscoverIcon.default,
    'icon-down': DownIcon.default,
    'icon-download': DownloadIcon.default,
    'icon-edit': EditIcon.default,
    'icon-error': ErrorIcon.default,
    'icon-export': ExportIcon.default,
    'icon-filter': FilterIcon.default,
    'icon-filter-alt': FilterIconAlt.default,
    'icon-filter-alt-fill': FilterIconAltFill.default,
    'icon-forward': ForwardIcon.default,
    'icon-fulfillment-delivery': FulfillmentDeliveryIcon.default,
    'icon-help': HelpIcon.default,
    'icon-info': InfoIcon.default,
    'icon-jcb': JCBIcon.default,
    'icon-kit': KitIcon.default,
    'icon-locationpin': LocationPinIcon.default,
    'icon-maestro': MaestroIcon.default,
    'icon-mastercard': MastercardIcon.default,
    'icon-menu': MenuIcon.default,
    'icon-minus': MinusIcon.default,
    'icon-mir': MIRIcon.default,
    'icon-nonreturnable': NonReturnableIcon.default,
    'icon-order': OrderIcon.default,
    'icon-partial-success': PartialSuccessIcon.default,
    'icon-paypal': PaypalIcon.default,
    'icon-pdf': PdfIcon.default,
    'icon-plus': PlusIcon.default,
    'icon-preferences': PreferencesIcon.default,
    'icon-print': PrintIcon.default,
    'icon-profile': ProfileIcon.default,
    'icon-question': QuestionIcon.default,
    'icon-quote': QuoteIcon.default,
    'icon-radiobutton-selected': RadioButtonSelectedIcon.default,
    'icon-radiobutton-unselected': RadioButtonUnselectedIcon.default,
    'icon-remanufactured': RemanufacturedIcon.default,
    'icon-replacement-part': ReplacementPartIcon.default,
    'icon-reorder': ReorderIcon.default,
    'icon-sale': SaleIcon.default,
    'icon-save': SaveIcon.default,
    'icon-search': SearchIcon.default,
    'icon-share': ShareIcon.default,
    'icon-shoppingcart': ShoppingCartIcon.default,
    'icon-social-facebook': SocialFacebookIcon.default,
    'icon-social-linkedin': SocialLinkedInIcon.default,
    'icon-social-twitter': SocialTwitterIcon.default,
    'icon-social-youtube': SocialYouTubeIcon.default,
    'icon-sortby': SortByIcon.default,
    'icon-success': SuccessIcon.default,
    'icon-star': StarIcon.default,
    'icon-store': StoreIcon.default,
    'icon-sync': SyncIcon.default,
    'icon-up': UpIcon.default,
    'icon-view-grid': ViewGridIcon.default,
    'icon-view-list': ViewListIcon.default,
    'icon-visa': VisaIcon.default,
    'icon-waffle': WaffleIcon.default,
    'icon-warning': WarningIcon.default,
    'icon-warning-outline': WarningOutlineIcon.default,
    'icon-actions': ActionsIcon.default,
    'icon-private': PrivateIcon.default,
    'icon-shared': SharedIcon.default,
    'icon-attachment': AttachmentIcon.default,
    'icon-minus-light': MinusLightIcon.default,
    'icon-cat-card': CatCardIcon.default,
    'icon-check': CheckIcon.default,
    'icon-open-in-new-tab': OpenInNewTabIcon.default,
    'icon-repair-service': RepairServiceIcon.default,
    'icon-square-help': SquareHelpIcon.default,
    'icon-visibility-off': VisibilityOffIcon.default,
    'icon-filled-star': FilledStarIcon.default
  };
  var selectedIcon = iconMap[icon] || function () {
    throw "".concat(ICON_NOT_FOUND_ERROR, " ").concat(icon);
  };
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: selectedIcon(_objectSpread({}, otherProps))
  });
};
AlloyIcon.propTypes = {
  icon: PropTypes__default.default.string.isRequired,
  title: PropTypes__default.default.string,
  height: PropTypes__default.default.oneOfType([PropTypes__default.default.number, PropTypes__default.default.string]),
  width: PropTypes__default.default.oneOfType([PropTypes__default.default.number, PropTypes__default.default.string]),
  className: PropTypes__default.default.string
};
AlloyIcon.__docgenInfo = {
  "description": "This component has been deprecated. Please use the icon directly as component: `<AlloyIcon icon =\"icon-back\" />` --> `<BackIcon />`\r\n@deprecated",
  "methods": [],
  "displayName": "AlloyIcon",
  "props": {
    "icon": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "title": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "height": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "width": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "className": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var AlloyIcon$1 = AlloyIcon;

exports.default = AlloyIcon$1;
//# sourceMappingURL=AlloyIcon.js.map
